export const columnOptions: Array<{
  value: string;
  label: string;
}> = [
  { label: 'Cliente', value: 'CLIENTE' },
  { label: 'Fazenda', value: 'FAZENDA' },
  { label: 'Código', value: 'CODIGO' },
  { label: 'Descrição', value: 'DESCRICAO' },
  { label: 'Lote', value: 'LOTE' },
  { label: 'Unidade', value: 'UNIDADE' },
  { label: 'Quantidade', value: 'QTD' },
  { label: 'Entrada', value: 'ENTRADA' },
  { label: 'Fabricação', value: 'FABRICACAO' },
  { label: 'Vencimento', value: 'VENCIMENTO' },
  { label: 'NF', value: 'NF' },
  { label: 'Valor unitário', value: 'VALOR UNIT' },
  { label: 'Valor total', value: 'VALOR TOTAL' },
];